<template lang="pug">
    button.w-full.text-sm.border.rounded(
        :disabled="disabled"
        @click="onClick"
    )
        slot {{ value }}
</template>

<script>
export default {
    name: "RegularButton",
    props: {
        value: {
            type: String,
            default: () => {
                return 'click me!'
            }
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onClick(event) {
            if (this.disabled) {
                event.preventDefault()
                return
            }
            this.$emit('click')
        },
    },
}
</script>